module.exports = __webpack_public_path__ + "img/V25.2c283a4d.jpg";